<template>
  <div class="user-editor">
    <div class="form-group">
      <div class="selector-button-label text-medium pl-2 ml-1 pb-1">{{ placeholder }}</div>
      <single-select
        :options="users"
        :value="selectedUser"
        @select="onUserSelect($event)"
        placeholder="Select a user"
      >
        <template v-slot:default="item">
          <div class="d-flex user-pill">
            <user-short class="pl-2" :user-id="item.value.id" length="18"></user-short>
            <span class="user-text text-truncate" :title="item.value.displayName">{{
              item.value.displayName
            }}</span>
          </div>
        </template>
        <template v-slot:listItem="option">
          <div class="d-flex dropdown-item-container">
            <user-short class="pl-2" :user-id="option.option.id" length="18"></user-short>
            <span class="user-text pl-2">{{ option.option.displayName }}</span>
          </div>
        </template>
      </single-select>
    </div>
    <div class="pt-1">
      <submit-buttons
        class="pl-2"
        @save="$emit('save', selectedUserId)"
        @cancel="$emit('cancel')"
      />
    </div>
  </div>
</template>

<script>
import SubmitButtons from '@/components/SubmitButtons'
import MembershipsMixin from '@/mixins/MembershipsMixin'
import UserShort from '@/components/UserShort'
import SingleSelect from '@/components/form/SingleSelect'

export default {
  name: 'OwnershipEditor',
  components: {
    UserShort,
    SingleSelect,
    SubmitButtons
  },
  props: ['selected', 'teamId', 'orgId', 'placeholder'],
  mixins: [MembershipsMixin],
  data() {
    return {
      users: [],
      selectedUserId: this.selected
    }
  },
  computed: {
    selectedUser() {
      if (this.selectedUserId) {
        return this.$store.getters.userById(this.selectedUserId)
      } else {
        return null
      }
    },
    team() {
      return this.teamId ? this.$store.getters.teamById(this.teamId) : null
    }
  },
  methods: {
    onUserSelect(user) {
      this.selectedUserId = user && user.id
    }
  },
  async mounted() {
    await this.updateMemberships(this.orgId, this.teamId, this.team?.isPrivate)
    const users = this.getUsersInScope(this.teamId, this.orgId)
    this.users = users
      .sort((a, b) => {
        return a.displayName.toLowerCase().localeCompare(b.displayName.toLowerCase())
      })
      .map(user => ({ ...user, label: user.displayName }))
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/_styleConfigurations.scss';
@import '~@/styles/components/input';

/deep/ .user-short-container:focus {
  outline: none;
}

.none-item-text {
  padding-left: 24px;
}

.multi-user-popover {
  background: #f6f6f6;
  border-radius: 16px;
}

/deep/ .none-item .dropdown-item {
  padding-left: 20px;
}

.form-group {
  margin-bottom: 12px;
}

.user-text {
  top: 2px;
  font-size: 0.875rem;
  line-height: 18px;
}

/deep/ .dropdown-item {
  padding-top: 0;
  padding-bottom: 0;
}

/deep/ .dropdown-menu {
  max-height: 250px;
  overflow-y: auto;
}

.dropdown-item-container {
  padding-top: 4px;
  padding-bottom: 4px;
  font-size: 0.875rem;
}

.user-pill {
  padding: 2px 0 1px;

  /deep/ .user-short-container {
    padding: 0 5px 0 4px !important;
  }
}

/deep/ .user-short-container {
  padding-top: 0 !important;
}
</style>
